import tippy, {followCursor} from 'tippy.js';

export default class Tooltip {
    constructor() {
        tippy('[data-tippy-content]', {
            followCursor: true,
            plugins: [followCursor],
            animation: true,
            touch: false,
            arrow: false
        });
    }
}